'use strict';

var _extends = require('../../../../@babel/runtime/helpers/esm/extends.js');
var defaultTheme = require('./defaultTheme.js');
var makeStyles$1 = require('../../../styles/esm/makeStyles/makeStyles.js');

function makeStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return makeStyles$1(stylesOrCreator, _extends({
    defaultTheme: defaultTheme
  }, options));
}

module.exports = makeStyles;
